"use strict";

exports.__esModule = true;
exports.DeviceDetailsWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DeviceDetailsElement = require("./DeviceDetailsElement");
var _DeviceDetailsFields = require("./DeviceDetailsFields");
var _DeviceDetailsHeader = require("./DeviceDetailsHeader");
var _DeviceDetailsWidgetThumbnail = require("./DeviceDetailsWidgetThumbnail");
var _EditableDeviceDetailsElement = require("./EditableDeviceDetailsElement");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DeviceDetailsWidget = exports.DeviceDetailsWidget = {
  name: "DeviceDetails",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DeviceDetailsWidget.label",
    defaultMessage: "Device Details"
  }),
  ignoreHeading: true,
  group: _widgetGroups.DEVICE_INFORMATION_WIDGET,
  icon: "dashboard",
  createElement: function createElement(props) {
    return {
      type: "DeviceDetails",
      props: Object.assign({
        width: 1024,
        height: 768,
        rowCount: 12,
        columnCount: 12
      }, props),
      children: []
    };
  },
  showInPalette: false,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: ["device"],
  optionalProps: [],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: ["x", "y", "width", "height"],
  propConstraints: {
    width: {
      "default": 1024,
      min: 128,
      max: 3840
    },
    height: {
      "default": 768,
      min: 128,
      max: 2160
    }
  },
  components: {
    Header: _DeviceDetailsHeader.DeviceDetailsHeader,
    Element: _DeviceDetailsElement.DeviceDetailsElement,
    Fields: _DeviceDetailsFields.DeviceDetailsFields,
    Editable: _EditableDeviceDetailsElement.EditableDeviceDetailsElement,
    Thumbnail: _DeviceDetailsWidgetThumbnail.DeviceDetailsWidgetThumbnail
  }
};